module.exports = __webpack_public_path__ + "static/media/flow_add.eb688d45.svg";